import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const CustomHTMLHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on top.
    <br/>
    <img src={makeToolTipUrl('custom-html/1.CMS-HTML-headline.png')} width="100%"/>
  </div>
);

export const CustomHTMLIntroToolTip = (props) => (
  <div>
    Copy that introduces the content.
    <br/>
    <img src={makeToolTipUrl('custom-html/2.CMS-HTML-intro.png')} width="100%"/>
  </div>
);

export const CustomHTMLCustomCodeToolTip = (props) => (
  <div>
    HTML code to support coupons or a custom client need. (If you don’t know code, find someone who does).
  </div>
);

export const CustomHTMLCustomCssToolTip = (props) => (
  <div>
    CSS code to support coupons or a custom client need. (If you don’t know code, find someone who does).
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/custom-html-tool-tips.jsx